export class ObjectsActionContext {
    params;
    allActions = [];
    wfRules = [];
    callbacks = {};
    startWorkflow;
    constructor(params) {
        this.params = params;
    }
    get actions() {
        const isInCollection = !!this.params.selection?.collectionId;
        if (isInCollection) {
            return this.allActions.filter(action => action.id !== 'addToCollection' && action.id !== 'delete');
        }
        else {
            return this.allActions.filter(action => action.id !== 'removeFromCollection' && action.id !== 'deleteFromCollections');
        }
    }
    registerCallback(name, cb) {
        this.callbacks[name] = cb;
        return () => {
            delete this.callbacks[name];
        };
    }
    unregisterCallback(name) {
        delete this.callbacks[name];
    }
    findAction(actionId) {
        let action = this.allActions.find(a => a.id === actionId);
        if (!action) {
            action = this.wfRules.find(a => a.id === actionId);
        }
        return action;
    }
    async run(actionId) {
        const action = this.findAction(actionId);
        if (!action) {
            throw new Error(`Action ${actionId} not found`);
        }
        const params = { ...this.params, action };
        const cb = this.callbacks[actionId];
        if (cb) {
            return cb(params);
        }
        else {
            throw new Error("No action callback set");
        }
    }
}
//# sourceMappingURL=ObjectsActionContextClass.js.map